exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___3-bfS {\n  align-items: stretch;\n  display: flex;\n  flex-direction: column;\n}\n.validateLinkButton___2PfT5 {\n  margin: initial;\n  margin-top: 22px;\n}\n.zoomLinkFields___vi7LJ {\n  display: flex;\n  flex-wrap: nowrap;\n  margin-bottom: 20px;\n}\n.zoomLinkInput___1_tEN {\n  flex-grow: 1;\n}\n.marginRight___2HK43 {\n  margin-right: 12px;\n}\n.eventFields___3dJBQ {\n  display: flex;\n  margin-bottom: 20px;\n}\n.eventFields___3dJBQ > * {\n  flex-grow: 1;\n}\n.button___2_gEk {\n  align-self: flex-start;\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___3-bfS",
	"validateLinkButton": "validateLinkButton___2PfT5",
	"zoomLinkFields": "zoomLinkFields___vi7LJ",
	"zoomLinkInput": "zoomLinkInput___1_tEN",
	"marginRight": "marginRight___2HK43",
	"eventFields": "eventFields___3dJBQ",
	"button": "button___2_gEk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ExistingZoomLinkForm/ExistingZoomLinkForm.module.less
// module id = 2342
// module chunks = 51